export const TRAIN_MARKET_ROUTES = {
  INVITE_FRIEND: 'inviteFriend',
  INVITE_FRIEND_SHARE: 'inviteFriendShare',
}

export default [
  {
    path: '/market/inviteFriendReceiver',
    name: TRAIN_MARKET_ROUTES.INVITE_FRIEND,
    meta: {
      title: '请好友看',
      isNotShare: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "trainMarketInviteFriend" */ '@/pages/study/Market/inviteFriendReceiver/index.vue'
      ),
  },
  {
    path: '/market/inviteFriendShare',
    name: TRAIN_MARKET_ROUTES.INVITE_FRIEND_SHARE,
    meta: {
      title: '请好友看',
    },
    component: () =>
      import(
        /* webpackChunkName: "trainMarketInviteFriendShare" */ '@/pages/study/Market/inviteFriendShare/index.vue'
      ),
  },
]
